import React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import BlockHeader from "../components/blockheader"

function AboutCard(props) {
  return (
    <div className="w-full md:w-1/3 p-4 flex flex-col flex-grow flex-shrink">
      <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
        <a href="#" className="flex flex-wrap no-underline hover:no-underline justify-center">

          <div className="w-full font-bold text-2xl text-gray-800 px-6 mt-2">
            {props.title}
          </div>
          <p className="w-full text-gray-600 text-base px-6 mb-5 mt-2">
            {props.message}
          </p>
        </a>
      </div>
      <div className="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow p-6">
        <div className="flex items-center justify-start">
          <Link to={props.destination}>
            <buttons className="mx-auto lg-mx-0 cursor-pointer hover:underline text-gray-800 font-extrabold rounded my-7 py-4 px-8 shadow-lg">
              {props.action}
            </buttons>
          </Link>
        </div>
      </div>
    </div>
  )
}

function ArticleCard(props){
  return(
    <ul className="md:w-1/2 px-4 border-gray-600 border-b pb-6 pt-6">
      <div className="flex items-center">
        {props.icon}
        <h3 className="font-bold text-xl text-bold mb-2">{props.title}</h3>
      </div>
      <p className="text-sm">{props.description}</p>
      <div className="flex items-center py-3">
        <svg className="h-6 pr-3 fill-current text-blue-300"
          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0zm-8 2H5V8h5V5l5 5-5 5v-3z"/>
        </svg>
        <Link to={props.destination} className="bold border-b-2 border-blue-300 hover:text-blue-300">Read more</Link>
      </div>
    </ul>
  )
}

class BlogIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="Landing Last Minute"
        />
        <div className="container mx-auto max-w-5xl">
          <h1 className="my-4 text-2xl md:text-3xl lg:text-5xl font-black leading-tight">
            Helping People Connect
          </h1>
          <p className="leading-normal text-gray-800 text-base md:text-xl lg:text-2xl mb-8">
            <strong>Landing last minute</strong> aims to make it easy for people to connect through travel and communication
          </p>
        </div>
        <section className="bg-gray-100 border-b py-8">
          <div className="container mx-auto max-w-5xl flex flex-wrap pt-4 pb-12">
            <AboutCard
              title="Travel"
              message="Making it easy to stay in touch with people by travelling. I feel there's nothing better than meeting someone face to face. This means travel. My name's Chris and I write guides to make travelling easier."
              action="See More"
              destination="/read"
              icon={
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 640 640"><path d="M198.652 621.563c0-55.1 30.284-81.036 70.123-110.93V366.478L7.145 482.712c0-100.608-34.24-93.237 47.116-144.356l.803-.496v-62.871h58.418v26.48l42.922-26.74v-70.442h58.418v34.052l53.953-33.615V55.891c0-20.93 22.737-38.043 50.528-38.043h.012c27.792 0 50.528 17.15 50.528 38.043v148.833l54.532 33.97v-34.407h58.418v70.796l42.934 26.73v-26.824h58.406v63.213c81.025 50.34 50.068 40.513 50.068 144.51L369.843 366.325V509.95c42.39 28.3 70.11 49.985 70.11 111.616l-66.697.58c-15.26-12.001-25.854-21.096-33.98-27.391-6.142 2.008-12.898 3.118-19.961 3.118h-.012c-7.985 0-15.58-1.417-22.312-3.933-8.752 6.378-20.338 15.815-37.547 28.205l-60.792-.579z"/></svg>
              }
            />
            <AboutCard
              title="Communication"
              message="Staying in touch, particularly when travelling, is important. I write guides here to demistify what it means to communicate across borders and how to stay in touch even when on the move."
              action="See More"
              destination="/read"
              icon={
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 1333.34 1332.32" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd"><path d="M323.23 644.52c39.44 71.14 84.87 139.46 144.04 201.8 59.17 62.69 132.77 119.74 228.21 168.34 7.04 3.52 13.73 3.52 19.72 1.06 9.16-3.52 18.32-10.92 27.47-20.07 7.05-7.05 15.85-18.32 25-30.64 36.63-48.25 82.06-108.12 146.15-78.19 1.41.7 2.47 1.41 3.87 2.11l213.77 122.91c.7.35 1.41 1.06 2.11 1.41 28.17 19.37 39.8 49.31 40.15 83.12 0 34.51-12.68 73.25-31.34 106-24.65 43.31-60.93 71.84-102.83 90.85-39.8 18.31-84.17 28.18-126.79 34.52-66.91 9.86-129.6 3.52-193.69-16.2-62.69-19.36-125.73-51.42-194.75-94.03l-4.93-3.17c-31.69-19.72-65.85-40.85-99.31-65.85-122.91-92.63-247.93-226.45-329.28-373.66C22.47 651.22-14.86 517.74 5.57 390.61c11.28-69.73 41.2-133.12 93.33-175.03 45.43-36.63 106.71-56.7 185.95-49.66 9.16.7 17.25 5.99 21.48 13.73l137 231.73c20.08 26.06 22.54 51.78 11.62 77.48-9.16 21.13-27.47 40.5-52.48 58.82-7.39 6.34-16.2 12.68-25.35 19.37-30.64 22.19-65.5 47.89-53.54 78.18l-.35-.7zm847.74-449.2c28.14 0 50.95 22.82 50.95 50.96s-22.81 50.95-50.95 50.95c-28.14 0-50.96-22.81-50.96-50.95 0-28.14 22.82-50.96 50.96-50.96zm-349.6-.19c28.21 0 51.07 22.86 51.07 51.06 0 28.2-22.87 51.05-51.07 51.05-28.21 0-51.05-22.85-51.05-51.05 0-28.2 22.83-51.06 51.05-51.06zm181.06 0c28.21 0 51.07 22.86 51.07 51.06 0 28.2-22.87 51.05-51.07 51.05-28.21 0-51.05-22.85-51.05-51.05 0-28.2 22.84-51.06 51.05-51.06zM792.23 0c-38.16 0-70.83 13.43-98 40.3-27.17 26.87-40.3 59.53-40.3 98v242.71c0 38.46 13.43 71.13 40.3 98 26.87 26.87 59.53 40.3 98 40.3h113.63c-7.93 30.53-17.7 59.53-29.91 86.7-11.91 27.48-32.36 53.73-60.45 78.77 54.04-14.04 101.97-35.11 144.41-62.89 42.13-27.48 78.77-61.98 108.99-102.58h126.15c38.16 0 70.83-13.74 98-40.3 27.17-26.87 40.29-59.54 40.29-98V138.3c0-38.17-13.43-70.83-40.29-98-26.87-27.17-59.53-40.3-98-40.3H792.24z" fill-rule="nonzero"/></svg>
              }
            />
          </div>
        </section>
        <section className="border-b py-8">
          <div className="container mx-auto max-w-5xl flex flex-wrap justify-center mx-2">
            <ArticleCard
              title="Australian SIM Cards Guide"
              destination="/australian-sim-card-guide"
              description="A guide for tourists, students, and business travellers on which SIM card to buy when arriving in Australia"
              icon={
                <svg className="h-8 mb-3 mr-3 fill-current text-gray"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M2 4v14h14v-6l2-2v10H0V2h10L8 4H2zm10.3-.3l4 4L8 16H4v-4l8.3-8.3zm1.4-1.4L16 0l4 4-2.3 2.3-4-4z"/>
                </svg>
              }
            />
            <ArticleCard
              title="Japan SIM Cards Guide"
              destination="/japan-sim-card-guide"
              description="A map to each of Japan's popular airports to help anyone arriving find a SIM card."
              icon={
                <svg className="h-8 mb-3 mr-3 fill-current text-gray"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9 12H1v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6h-8v2H9v-2zm0-1H0V5c0-1.1.9-2 2-2h4V2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1h4a2 2 0 0 1 2 2v6h-9V9H9v2zm3-8V2H8v1h4z"/>
                </svg>
              }
            />
            <ArticleCard
              title="How to Receive Calls While Overseas"
              destination="/receive-calls-overseas-guide"
              description="There are many ways to receive calls while travelling to another country. This guide is a detailed how-to with costs for each option."
              icon={
                <svg className="h-8 mb-3 mr-3 fill-current text-gray"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M3 6c0-1.1.9-2 2-2h8l4-4h2v16h-2l-4-4H5a2 2 0 0 1-2-2H1V6h2zm8 9v5H8l-1.67-5H5v-2h8v2h-2z"/>
                </svg>
              }
            />
          </div>
        </section>
        <section className="border-b py-8">
          <div className="container mx-auto max-w-5xl flex flex-wrap pt-4 pb-12 justify-center">
            <div className="md:w-1/2 rounded rounded-t-lg overflow-hidden shadow my-3">
              <BlockHeader title={"About"}/>
              <div className="flex justify-center mt-3">
                <Img
                  fixed={data.avatar.childImageSharp.fixed}
                  alt={data.site.siteMetadata.author}
                  className="border-solid border-white border-2 -mt-1"
                />
              </div>
              <div className="text-center px-3 pb-6 pt-2">
                <div className="mt-2 font-light text-grey-dark">
                  <p>Written by <strong>{data.site.siteMetadata.author}</strong> who travels frequently for work and understands what it can be like to arrive somewhere new and unfamiliar.</p>
                  <p>I wrote <em>Landing Last Minute</em> to help the hurried traveler get necessary information about any destination.</p>
                </div>
              </div>
            </div>
        
          </div>
        </section>
      </Layout>
    )

    /*

    
        {Row 1}
        <div className="flex items-center h-10">

          <div className="flex-none md:w-10/12">
          </div>

        </div>

        {/*Row 2}
        <div className="flex items-center h-48">
          <div className="md:flex-none md:w-2/12">
          </div>

          <div className="md:flex-none md:w-3/12 border-l-4 border-indigo pl-2">
            <header>
              <h1 className="leading-tight text-4xl font-semibold p-1">Landing Last Minute</h1>
              <p className="p-1"><em>Helping people travel easily</em></p>
            </header>
          </div>

          <div className="md:flex-none md:w-1/12">
          </div>

          

        </div>

        {/*Row 3}
        <div className="flex items-center h-10">

          <div className="md:flex-none md:w-10/12">
          </div>

        </div>
        
        {/*Row 4}
        <div className="flex flex-wrap h-64 md:h-48">
          <div className="md:flex-none md:w-2/12">
          </div>

          <div className="w-full md:flex-none md:w-4/12 pl-2 mt-1 pr-2">
            <h3 className="p-1 font-bold">Recent</h3>
            {posts.map(( {node} ) => {
              const title = node.frontmatter.title || node.fields.slug
              return(
                <Link to={node.fields.slug}>
                  <h2 className="text-xl p-1 border-l-4 border-indigo mt-1 cursor-pointer">
                    {title}
                  </h2>
                </Link>
              )
            })}
            
          </div>

          <div className="w-full md:flex-none md:w-4/12 mt-1 md:ml-1 pl-2">
            <h3 className="p-1 font-bold">Guides</h3>
            <div className="text-xl mt-1 p-1 cursor-pointer border-l-4 border-indigo">
              <Link to={"/australian-sim-card-guide"}>Australia SIM Cards Guide</Link>
            </div>
            <div className="text-xl mt-1 p-1 cursor-pointer border-l-4 border-indigo">
              <Link to={"/new-zealand-sim-card-guide"}>New Zealand SIM Cards Guide</Link>
            </div>
            <div className="text-xl mt-1 p-1 cursor-pointer border-l-4 border-indigo">
              <Link to={"/japan-sim-card-guide"}>Japan SIM Cards Guide</Link>
            </div>
            
          </div>

        </div>

        {/*Row 5}
        <div className="flex items-center h-48">

          <div className="w-full md:flex-none md:w-10/12">
          </div>

        </div>

        {/*Row 6}
        <div className="flex items-center h-60">

          <div className="md:flex-none md:w-2/12">
          </div>

          <div className="md:flex-none w-full md:w-4/12 pr-1">
            <Img
              fluid={data.back_one.childImageSharp.fluid}
              alt="Taiwan"
            />
          </div>

          <div className="md:flex-none w-full md:w-4/12 pl-1">
            <Img
              fluid={data.back_two.childImageSharp.fluid}
              alt="Sydney"
            />
          </div>

        </div>
*/
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    avatar: file(absolutePath: { regex: "/me_hkg__43_750.jpg/" }) {
      childImageSharp {
        fixed(width: 132, height: 86) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        title
        siteUrl
        author
      }
    }
    file(absolutePath: { regex: "/splash.jpg/" }) {
      childImageSharp {
        fluid (maxWidth: 786){
          ...GatsbyImageSharpFluid
        }
      }
    }
    back_one: file(absolutePath: { regex: "/background_one.jpg/" }) {
      childImageSharp {
        fluid (maxHeight: 240) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    back_two: file(absolutePath: { regex: "/background_two.jpg/" }) {
      childImageSharp {
        fluid (maxHeight: 240) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC } limit:3) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            cover_image {
              childImageSharp {
                resize (width:1500, height: 1500) {
                  src
                }
                fluid (maxWidth: 786) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            cover_image_caption
          }
        }
      }
    }
  }
`
